module.exports = __webpack_public_path__ + "static/img/banlishebao.2efeb57a.png";